import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchGroups = createAsyncThunk(
  "groups/fetchGroups",
  async () => {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      "https://v3.dhundhoo.com/ev/getThingGroupsMasterDetails",
      { timeZone: null }, // <-- body
      {
        headers: {        // <-- config (headers go here)
          "x-dhundhoo-session": token,
        },
      }
    );

    return response.data;
  }
);
